import { render, staticRenderFns } from "./AddElements.vue?vue&type=template&id=98963716"
import script from "./AddElements.vue?vue&type=script&lang=js"
export * from "./AddElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports